module.exports = {
    homepage: "http://192.168.1.50/home",
    root:"",
    apiUrl: "http://192.168.1.50",
};
